import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import '../static/css/main.css'
import store from './store/index'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import QRCode from 'qrcode'
import Print from 'vue-print-nb' //打印
Vue.use(Print)

// 全局公共接口api
Vue.prototype.$api = require('./api/index').default

Vue.config.productionTip = false;

Vue.prototype.$isNumber = function(i){
	return isNaN(i) ? !0 : i < 1 || i === '' ? !0 : false;
}
Vue.prototype.$QRCode = function(i){
	let newUrl = '';
	QRCode.toDataURL(i, { errorCorrectionLevel: 'L', margin: 0, width: 120 }, (err, url) => {
		if (err) throw err
		newUrl =  url;
	});
	return newUrl;
}

var vue = new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
export default vue
router.afterEach(function (to, from) {
	document.title = to.meta.title;
	if(to.path !== '/login' && to.path !== '/register' && to.path !== '/forgotPassword'){
		if(to.path !== '/articleDetail'){
			if(localStorage.getItem('SMART_FARMING_TOKEN') === null){
				vue.$router.push('/login')
			}else{
				store.state.token = localStorage.getItem('SMART_FARMING_TOKEN');
				store.state.profile = JSON.parse(localStorage.getItem('SMART_FARMING_PROFILE'));
				if(store.state.profile.adminFlag === 'YES'){
					store.state.profile.pageCodes = ['1-1-1-1', '1-1-1-2', '1-1-1-3', '1-1-1-4', '1-1-1-5', '1-1-1-6', '1-1-2-1', '1-1-2-2', '1-1-2-3', '1-1-3', '1-2-1-1', '1-2-1-2', '1-2-1-3', '1-2-1-4', '1-2-1-5', '1-2-1-6', '1-2-1-7', '1-2-2-1', '1-2-2-2', '1-2-2-3', '1-2-3-1', '1-2-3-2', '1-2-3-3', '1-3', '1-3-1', '1-3-2', '1-3-3', '2-1-1', '2-1-2', '2-1-3', '2-2-1', '2-2-2', '2-2-3', '2-3-1', '2-4-1', '2-4-2', '2-4-3', '2-4-4', '2-4-5', '2-5-1', '2-5-2', '2-5-3', '2-5-4', '2-5-5', '2-5-6', '2-5-7', '2-5-8', '2-5-9', '2-6-1', '2-6-2', '2-6-3-1', '2-6-3-2', '3-1-1', '3-1-2', '3-1-3', '3-1-4', '3-1-5', '3-2-1', '3-2-2', '3-2-3', '3-3-1', '3-3-2', '3-3-3', '3-3-4', '3-4-1', '3-4-2', '3-4-3', '3-5-1', '3-5-2', '3-5-3',  '4-1-1-1', '4-1-1-2', '4-1-1-3', '4-1-1-4', '4-1-1-5', '4-1-1-6', '4-1-1-7', '4-1-2-1', '4-1-2-2', '4-1-2-3', '4-1-2-4', '4-1-2-5', '4-1-2-6', '4-1-2-7', '4-1-3-1', '4-1-3-2', '4-1-3-3', '4-1-3-4', '4-1-3-5', '4-1-3-6', '4-1-3-7', '4-1-4-1', '4-1-4-2', '4-2-1-1', '4-2-1-2', '4-2-1-3', '4-2-1-4', '4-2-1-5', '4-2-1-6', '4-2-1-7', '4-2-2-1', '4-2-2-2', '4-2-2-3', '4-2-2-4', '4-2-2-5', '4-2-2-6', '4-2-2-7', '4-2-3-1', '4-2-3-2', '4-2-3-3', '4-2-3-4', '4-2-3-5', '4-2-3-6', '4-2-3-7', '4-2-4-1', '4-2-4-2', '4-3-1-1', '4-3-1-2', '4-3-1-3', '4-3-1-4', '4-3-1-5', '4-3-1-6', '4-3-1-7', '4-3-2-1', '4-3-2-2', '4-3-2-3', '4-3-2-4', '4-3-2-5', '4-3-2-6', '4-3-2-7', '4-3-3-1', '4-3-3-2', '4-3-3-3', '4-3-3-4', '4-3-3-5', '4-3-3-6', '4-3-3-7', '4-3-4', '4-3-5-1', '4-3-5-2', '4-3-5-3', '4-3-6-1', '4-3-6-2', '4-3-6-3', '4-3-6-4', '4-3-6-5', '4-3-6-6', '4-3-6-7', '4-3-7-1', '4-3-7-2', '4-3-7-3', '4-3-7-4', '4-3-7-5', '4-3-7-6', '4-3-7-7', '4-4-1', '4-4-1', '4-4-2', '4-4-3', '4-4-4', '4-4-5', '4-4-6', '4-4-7', '4-5-1-1', '4-5-1-2', '4-5-1-3', '4-5-2-1', '4-5-2-2', '4-5-2-3', '4-5-2-4-1', '4-5-2-4-2', '4-5-2-4-3', '4-5-3-1', '4-5-3-2', '4-5-3-3', '4-5-4-1', '4-5-4-2', '4-5-4-3', '4-5-5-1', '4-5-5-2', '4-5-5-3', '4-5-5-4-1', '4-5-5-4-2', '4-5-5-4-3', '5-1-1', '5-1-2', '5-1-3', '5-1-4', '5-1-5', '5-1-6', '5-1-7', '5-1-8', '5-2', '6-1-1', '6-1-2', '6-2', '6-3-1', '6-3-2', '6-3-3', '6-3-4', '6-3-5', '7-1', '7-2-1', '7-2-2', '7-2-3', '4-6-1-1', '4-6-1-2', '4-6-1-3', '4-6-1-4', '4-6-1-5', '4-6-1-6', '4-6-1-7', '4-6-1-8', '4-6-2-1', '4-6-2-2', '4-6-2-3', '4-6-2-4', '4-7-1-1', '4-7-1-2', '4-7-1-3', '4-7-1-4', '4-7-1-5', '4-7-1-6', '4-7-1-7', '4-7-1-8', '4-7-2-1', '4-7-2-2', '4-7-2-3', '4-7-2-4', '4-8-1-1', '4-8-1-2', '4-8-1-3', '4-8-1-4', '4-8-1-5', '4-8-1-6', '4-8-1-7', '4-8-2-1', '4-8-2-2', '4-8-2-3', '4-8-2-4', '4-8-2-5', '4-8-2-6', '4-8-2-7', '4-8-3-1', '4-8-3-2', '4-9-1', '4-9-2', '4-9-3', '4-9-4', '4-9-5', '4-9-6', '4-10-1-1', '4-10-2-1', '4-10-3-1', '4-10-4-1', '4-10-5-1', '4-10-6-1', '4-10-7-1']
				}
				store.state.profile.off = store.state.profile.companyId === store.state.profile.selfCompanyId ? !0 : !1;
				if(to.path !== '/improveData' && to.path !== '/csfsz~fieldSettings' && to.path !== '/csfsz~groupSettings'){
					if(store.state.profile.companyId === 0){
						vue.$router.push('/improveData')
					}else if(store.state.profile.setFlag === 1){
						vue.$message('请设置场');
						vue.$router.push('/csfsz~fieldSettings')
					}else if(store.state.profile.setFlag === 2){
						vue.$message('请设置群');
						vue.$router.push('/csfsz~groupSettings')
					}
				}
			}
		}
		
	}
})



// WEBPACK FOOTER //
// ./src/main.js